import { render } from "./AskusAttributeBadges.vue?vue&type=template&id=ae2ac2d8&ts=true"
import script from "./AskusAttributeBadges.vue?vue&type=script&lang=ts"
export * from "./AskusAttributeBadges.vue?vue&type=script&lang=ts"

import "./AskusAttributeBadges.vue?vue&type=style&index=0&id=ae2ac2d8&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__